// extracted by mini-css-extract-plugin
export default {"container":"IC-z","modal":"JC-z","dimensions":"KC-z","brandName":"LC-z","productName":"MC-z","labelValue":"NC-z","recipientEmail":"OC-z","recommendedFit":"PC-z","hiddenField":"QC-z"};